import Cookies from 'js-cookie'

 function getToken(TokenKey) {
  return Cookies.get(TokenKey)
}

 function setToken(TokenKey, token) {
  return Cookies.set(TokenKey, token)
}

 function removeToken(TokenKey) {
  return Cookies.remove(TokenKey)
}
export {getToken, setToken, removeToken }


// WEBPACK FOOTER //
// ./src/assets/js/auth.js